<template>
  <AddDevice :defaultOpenScreen="deviceType" :hideClose="true" />
</template>

<script>
import AddDevice from "@/components/AddDevice";

export default {
  name: "AddDeviceView",
  data: function () {
    return {
      deviceType: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ? 'mobile' : 'desktop',
    }
  },
  components: { AddDevice },
}
</script>

<style scoped>

</style>